import React from 'react';
import { useHistory } from 'react-router';

export default function PayHere({ row }) {
    const history = useHistory();

    const callInvoicepage = (event) => {
        event.preventDefault();
        history.push({
            pathname: '/menu/payment-invoice',
            state: { row },
        });
    };

    return (
        <>
            <a onClick={callInvoicepage} style={{ color: 'blue', cursor: 'pointer' }}>
                Pay Here
            </a>
        </>
    );
}
